<template>
  <div v-if="active" class="dialog-backdrop">
      <div class="dialog-container">
        <div class="message"><slot /></div>
      </div>
    </div>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    active: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.dialog-backdrop {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #404040;
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 99999;
}

.dialog-container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 5px;
  text-align: center;
  width: 90%;
}

.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.2s;
}
.dialog-enter,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .dialog-container,
.dialog-leave-active .dialog-container {
  transition: transform 0.4s;
}
.dialog-enter .dialog-container,
.dialog-leave-to .dialog-container {
  transform: scale(0.9);
}
.btn-close {
  color: #33a8ee;
  border: none;
  outline: none;
  background: none;
  padding-top: 15px;
}
.message {
  color: #fff;
  text-align: left;
  padding: 5px 0px;

}
/*  */

</style>